import { api } from '../api';

const WEBHOOK_BASE = '/webhooks';

const webhookApi = {
  // Get all webhooks for current user
  async getWebhooks(userId) {
    try {
      const response = await api.get(`${WEBHOOK_BASE}?userId=${userId}`);
      return { data: response || [], error: null };
    } catch (error) {
      console.error('Error fetching webhooks:', error);
      return { data: [], error: error.message || 'Failed to fetch webhooks' };
    }
  },

    async getWebhookLists() {
    try {
      const response = await api.get(`${WEBHOOK_BASE}/lists`);
      return { data: response || [], error: null };
    } catch (error) {
      console.error('Error fetching webhooks:', error);
      return { data: [], error: error.message || 'Failed to fetch webhooks' };
    }
  },

  // Get single webhook
  async getWebhook(webhookId) {
    try {
      const response = await api.get(`${WEBHOOK_BASE}/${webhookId}`);
      return { data: response, error: null };
    } catch (error) {
      console.error('Error fetching webhook:', error);
      return { data: null, error: error.message || 'Failed to fetch webhook' };
    }
  },

  // Create new webhook
  async createWebhook(webhookData) {
    try {
      const response = await api.post(WEBHOOK_BASE, webhookData);
      return { data: response, error: null };
    } catch (error) {
      console.error('Error creating webhook:', error);
      return { data: null, error: error.message || 'Failed to create webhook' };
    }
  },

  // Update webhook
  async updateWebhook(webhookId, webhookData) {
    try {
      const response = await api.put(`${WEBHOOK_BASE}/${webhookId}`, webhookData);
      return { data: response, error: null };
    } catch (error) {
      console.error('Error updating webhook:', error);
      return { data: null, error: error.message || 'Failed to update webhook' };
    }
  },

  // Delete webhook
  async deleteWebhook(webhookId) {
    try {
      await api.delete(`${WEBHOOK_BASE}/${webhookId}`);
      return { error: null };
    } catch (error) {
      console.error('Error deleting webhook:', error);
      return { error: error.message || 'Failed to delete webhook' };
    }
  },

  // Toggle webhook status
  async toggleWebhookStatus(webhookId, currentStatus) {
    try {
      console.log(currentStatus);
      
      const response = await api.patch(
        `${WEBHOOK_BASE}/${webhookId}/status`,
        { status: currentStatus === 'active' ? 'pause' : 'active' }
      );
      return { data: response, error: null };
    } catch (error) {
      console.error('Error toggling webhook status:', error);
      return { data: null, error: error.message || 'Failed to toggle webhook status' };
    }
  },

  // Test webhook
  async testWebhook(webhookId, payload) {
    try {
      const response = await api.post(
        `${WEBHOOK_BASE}/${webhookId}/test`,
        payload
      );
      return { data: response, error: null };
    } catch (error) {
      console.error('Error testing webhook:', error);
      return { data: null, error: error.message || 'Failed to test webhook' };
    }
  },

  // Get webhook delivery logs
  async getWebhookLogs(webhookId, filters = {}) {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      //`${WEBHOOK_BASE}/logs/${webhookId}?${queryParams}`
      const response = await api.get(
        `${WEBHOOK_BASE}/logs/${webhookId}?${queryParams}`
      );
      return { data: response || [], error: null };
    } catch (error) {
      console.error('Error fetching webhook logs:', error);
      return { data: [], error: error.message || 'Failed to fetch webhook logs' };
    }
  },

  // Retry failed webhook delivery
  async retryWebhookDelivery(logId) {
    try {
      const response = await api.post(
        `${WEBHOOK_BASE}/logs/${logId}/retry`
      );
      return { data: response, error: null };
    } catch (error) {
      console.error('Error retrying webhook delivery:', error);
      return { data: null, error: error.message || 'Failed to retry webhook delivery' };
    }
  },

  // Get webhook statistics
  async getWebhookStats(userId) {
    try {
      const response = await api.get(
        `${WEBHOOK_BASE}/stats?userId=${userId}`
      );
      return { data: response, error: null };
    } catch (error) {
      console.error('Error fetching webhook stats:', error);
      return { data: null, error: error.message || 'Failed to fetch webhook stats' };
    }
  }
};

export default webhookApi;
